export default {
  "b2b.zadost-detail.title": "Žádost {id}",
  "b2b.zadost-detail.not-found": "Žádost {id} nebyla nalezena"
};
